<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <path
      d="M22.3333 23V21.6667C22.3333 20.9594 22.0523 20.2811 21.5522 19.781C21.0521 19.281 20.3739 19 19.6666 19H14.3333C13.626 19 12.9478 19.281 12.4477 19.781C11.9476 20.2811 11.6666 20.9594 11.6666 21.6667V23"
      stroke="#FF8A71"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17 16.3333C18.4728 16.3333 19.6667 15.1394 19.6667 13.6667C19.6667 12.1939 18.4728 11 17 11C15.5273 11 14.3334 12.1939 14.3334 13.6667C14.3334 15.1394 15.5273 16.3333 17 16.3333Z"
      stroke="#FF8A71"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
